import { useEffect } from "react";
import axios from "axios";

/**
 * 自动从后端获取SEO设置，并动态注入Google Analytics和Site Verification
 */
export default function useInjectSEOSettings() {
  useEffect(() => {
    let injectedGA = false;
    let injectedSiteVerification = false;

    axios.get("/api/seo-settings")
      .then(res => {
        const settings = res.data || {};
        const gaId = settings.googleAnalyticsId || settings.google_analytics_id || "";
        const siteVerification = settings.googleSiteVerification || settings.google_site_verification || "";

        // 注入 Google Analytics（GA4）
        if (gaId && !injectedGA && !document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${gaId}"]`)) {
          // 1. 加载 gtag.js
          const gaScript = document.createElement("script");
          gaScript.async = true;
          gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
          document.head.appendChild(gaScript);

          // 2. 注入 gtag 配置
          const inlineScript = document.createElement("script");
          inlineScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}');
          `;
          document.head.appendChild(inlineScript);

          injectedGA = true;
        }

        // 注入 Google Site Verification
        if (siteVerification && !injectedSiteVerification) {
          // 只查找 name
          let meta = document.querySelector('meta[name="google-site-verification"]');
          if (!meta) {
            // 没有则新建
            meta = document.createElement("meta");
            meta.setAttribute("name", "google-site-verification");
            document.head.appendChild(meta);
          }
          meta.setAttribute("content", siteVerification);
          injectedSiteVerification = true;
        }
      })
      .catch(err => {
        // 可以根据需要处理错误
        // console.error("Failed to fetch SEO settings", err);
      });
  }, []);
}